import styled from 'styled-components';

const Panel = styled.div`
    flex-grow: 1;
    overflow: hidden;
    display: flex;
`;

export default Panel;
